import { render, staticRenderFns } from "./VerificationModeSwitch.vue?vue&type=template&id=24e281f2&scoped=true&"
import script from "./VerificationModeSwitch.vue?vue&type=script&lang=js&"
export * from "./VerificationModeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./VerificationModeSwitch.vue?vue&type=style&index=0&id=24e281f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e281f2",
  null
  
)

export default component.exports